import React, { useRef, useEffect, useCallback, memo } from 'react';
import ActivityItem from './ActivityItem';

const ActivityList = memo(({ activities, onLoadMore, hasMore, isLoading, onEdit, onDelete }) => {
  const loadMoreRef = useRef(null);

  // Intersection Observer for infinite scroll
  const handleObserver = useCallback((entries) => {
    const target = entries[0];
    if (target.isIntersecting && hasMore && !isLoading) {
      onLoadMore();
    }
  }, [hasMore, isLoading, onLoadMore]);

  useEffect(() => {
    const option = {
      root: null,
      rootMargin: '100px', // Load more when 100px before reaching the bottom
      threshold: 0
    };

    const observer = new IntersectionObserver(handleObserver, option);
    const currentRef = loadMoreRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [handleObserver]);

  return (
    <div className="activity-list">
      <div className="activity-list-header">
        <h2>ACTIVITY</h2>
        <h2>DATE</h2>
      </div>
      {activities.map((activity) => (
        <ActivityItem key={activity.id} activity={activity} onEdit={onEdit} onDelete={onDelete} />
      ))}
      {hasMore && (
        <div ref={loadMoreRef} style={{ padding: '20px', textAlign: 'center' }}>
          {isLoading ? (
            <div className="loading-indicator">Loading more activities...</div>
          ) : (
            <button
              className="load-more-button"
              onClick={onLoadMore}
            >
              Load More
            </button>
          )}
        </div>
      )}
    </div>
  );
});

ActivityList.displayName = 'ActivityList';

export default ActivityList;
